import React, { MouseEventHandler, useEffect } from "react";
import Badge from "../../components/Badge";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import H4 from "../../components/Typography/H4";
import { useFetchApi } from "../../hooks/useFetchApi";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import routes from "../../setup/routes";

const Entitlements: React.FC = (): React.ReactElement => {
  const {
    execute,
    loading,
    response: permissions,
  } = useFetchApi("/api/permissions", {}, "GET");

  const navigate = useNavigate();
  const toggle = (e: any, role: any) => {
    navigate(
      `${routes.DASHBOARD}/${routes.USER_MANAGEMENT}/${
        routes.ROLES
      }/${routes.ROLE_PERMISSIONS.replace(":id", role.id)}`
    );
  };

  useEffect(() => {
    execute();
  }, []);

  return (
    <div className="flex flex-col w-full p-8">
      <Loader show={loading} />
      {/* <AddEditModal data={selectedData} status={openModal.newEdit} onClose={toggle} onSuccess={execute}/>
            <DeleteModal id="delete" data={selectedData} status={openModal.delete} onClose={toggle} onSuccess={execute}/> */}
      <div className="flex justify-between mb-8 text-white">
        <H4>Entitlements</H4>
        {/* <Button id="newEdit" onClick={toggle} variant="primary">
          {" "}
          + Add New Entitlement{" "}
        </Button> */}
      </div>
      <table className="w-full">
        <tr>
          <th className="p-2 border-b">ID</th>
          <th className="p-2 border-b">Action Key</th>
          <th className="p-2 border-b">Status</th>
          <th className="p-2 border-b">Actions</th>
        </tr>
        {permissions && permissions.length ? (
          <>
            {permissions.map((permission: any) => (
              <tr className="border-b hover:bg-secondary cursor-pointer">
                <td className="p-2 text-center">{permission.id}</td>
                <td className="p-2 text-center">{permission.action_keys}</td>
                <td className="p-2 text-center">
                  <Badge status={permission.status ? "success" : "error"}>
                    {permission.status ? "Active" : "Inactive"}
                  </Badge>
                </td>
                <td className="flex w-full p-2 gap-2 justify-center text-white">
                  <Button
                    fontSize="small"
                    variant="primary"
                    id="newEdit"
                    onClick={(e: MouseEventHandler<HTMLButtonElement>) =>
                      toggle(e, permission)
                    }
                  >
                    Edit
                  </Button>
                  <Button
                    fontSize="small"
                    variant="error"
                    id="delete"
                    onClick={(e: MouseEventHandler<HTMLButtonElement>) =>
                      toggle(e, permission)
                    }
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={5}>No Data available. Add new</td>
          </tr>
        )}
      </table>
    </div>
  );
};

export default Entitlements;
